export function totalPages(itemCount, perPage) {
  if (!itemCount || !perPage) {
    return 0;
  }
  return Math.ceil(itemCount / perPage);
}
